import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { applyRouteMeta, metaForPath } from '../../utils/routeMeta';

/** Sets document title and canonical from the current route. */
const RouteMeta = (): null => {
  const { pathname } = useLocation();
  const { authenticated, loading } = useContext(AuthContext);

  useEffect(() => {
    if (loading) return;
    applyRouteMeta(metaForPath(pathname, authenticated));
  }, [pathname, authenticated, loading]);

  return null;
};

export default RouteMeta;
